import { useTheme } from '@/app/theme';
import { MoonIcon, SunIcon } from '@/components/ui/icons';
import { useTranslation } from '@/i18n';
import styles from './ThemeToggle.module.css';

/**
 * Switches between the light and dark themes.
 *
 * Labelled with the theme it will switch TO, not the one in use: a control that
 * states the current state reads as a status display, and the reader has the
 * current state in front of them already — the whole page is it.
 */
export const ThemeToggle = ({ showLabel = false }: { showLabel?: boolean }) => {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation();

  const goingDark = theme === 'light';
  const label = goingDark ? t('theme.dark') : t('theme.light');

  return (
    <button type="button" className={styles.button} onClick={toggle} title={label} aria-label={label}>
      {goingDark ? <MoonIcon className={styles.icon} /> : <SunIcon className={styles.icon} />}
      {showLabel && label}
    </button>
  );
};
